let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("38Axh")).then(() => parcelRequire('e9QtB'));